import {getAssetUrl} from "@Utils/s3.util.ts";

export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    /**
     * @param {object} props
     * @param {string} props.property
     * @param {string} props.label
     * @param {function} props.onClick
     * @param {function} props.onClear
     * @param {grapesjs.Component} props.component
     */
    styleManager.addType(window.PMW.emails.styles.ID_UPLOAD_BUTTON, {
        create({props, change}) {
            props.component = props.component || editor.getSelected();
            const labelContainer = getLabelContainer(props);
            attachButtonHandlers(props, change, labelContainer);

            return labelContainer;
        },

        emit({props, change}, {labelContainer, url, showDelete}) {
            updateLabelStylesOnUpload(props, labelContainer, url, showDelete);
        },
    });

    /**
     * show/hide delete button and stop icon on label
     * @param {object} props
     * @param {object} labelContainer
     * @param {string} [previewURL='']
     * @param {boolean} showDelete
     */
    function updateLabelStylesOnUpload(props, labelContainer, previewURL = '', showDelete) {
        const containerEl = $(labelContainer),
            deleteBtn = containerEl.find('.js-upload-delete-btn'),
            labelPreview = containerEl.find('.js-upload-preview');

        labelPreview.css('background-image', `url("${previewURL || ''}")`);
        if (showDelete) {
            deleteBtn.removeClass('_hidden');
        } else {
            deleteBtn.addClass('_hidden');
        }
    }

    /**
     * @param {object} props
     * @return {HTMLDivElement}
     */
    function getLabelContainer(props) {
        const labelContainer = document.createElement('div'),
            style = props.component.getStyle() || {},
            defaultPreviewURL = getAssetUrl('email-editor-upload-media-empty-placeholder.png'),
            previewURL = style[props.property]?.replace('"', '');

        labelContainer.className = props.type;
        labelContainer.innerHTML = `<div class="flex-justify-between _full-width">
                <span class="style-manager-label">${props.label}</span>
                <div class="flex-row-align-center">
                    <button class="btn clear-btn js-upload-delete-btn bg-neutral-0 border-s-darker radius-4 _cursor-pointer spacing-p-0 ${previewURL ? '' : '_hidden'}">
                        <i class="icon icon-delete body-m"></i>
                    </button>
                    <button class="btn js-upload-label-btn flex-center bg-neutral-0 border-s-dark _cursor-pointer radius-8 spacing-p-1 hover-transition-all">
                        <div class="upload-preview radius-4 spacing-m-r-1 js-upload-preview" style="background-image: ${previewURL || `url(${defaultPreviewURL})`};"></div>
                        <i class="pmw-icon icon-pencil content-body size-icon-16 js-upload-label-icon"></i>
                    </button>
                </div>
            </div>`;

        return labelContainer;
    }

    /**
     * @param {object} props
     * @param {function} change
     * @param {HTMLElement} labelContainer
     */
    function attachButtonHandlers(props, change, labelContainer) {
        PMW.onClick($(labelContainer), '.js-upload-label-btn', async function () {
            const previewURL = await new Promise(resolve => {
                if (typeof props.onClick === 'function') {
                    props.onClick(resolve);
                }
            });

            change({labelContainer, url: previewURL, showDelete: true});
        });

        PMW.onClick($(labelContainer), '.js-upload-delete-btn', function () {
            if (typeof props.onClear === 'function') {
                props.onClear();
            }

            change({labelContainer, url: getAssetUrl('email-editor-upload-media-empty-placeholder.png'), showDelete: false});
        });
    }
}